import { FormattedMessage, injectIntl } from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import messages from './messages';
import Grid from '../../components/Grid';
import Radio from '../../components/Radio';
import Dropdown from '../../components/Dropdown';
import states from './statesAndAbbreviations';
import './styles.css';
import Label from '../../components/Label';
import Icon from '../../components/Icon';

const Audience = ({ intl, index, audience, audienceStates, onChange, errors }) => (
  <React.Fragment>
    <Grid.Row>
      <Grid.Column width={3}>
        <b><FormattedMessage {...messages.meritScholarshipsAudienceLabel} /></b>
        <span styleName="required">&#x002a;</span>
      </Grid.Column>
      <Grid.Column width={8}>
        <Grid styleName="merit-scholarships-inner-grid">
          <Grid.Row styleName="merit-scholarships-inner-grid-row">
            <Radio
              key={`scholarship-key-radio-audience-all-${index}`}
              data-cy="scholarship-key-radio-audience-all"
              label={intl.formatMessage(messages.meritScholarshipsAllStudentsLabel)}
              name={`audienceRadioGroup-${index}`}
              aria-label="All students"
              value="ALL"
              checked={audience === 'ALL'}
              onChange={(e, { value }) => onChange({ target: { value } }, 'audience')}
            />
          </Grid.Row>
          <Grid.Row styleName="merit-scholarships-inner-grid-row">
            <Radio
              key={`scholarship-key-radio-audience-in-state-${index}`}
              data-cy="scholarship-key-radio-audience-in-state"
              label={intl.formatMessage(messages.meritScholarshipsInStateStudentsLabel)}
              name={`audienceRadioGroup-${index}`}
              aria-label="In state students only"
              value="IN_STATE"
              checked={audience === 'IN_STATE'}
              onChange={(e, { value }) => onChange({ target: { value } }, 'audience')}
            />
          </Grid.Row>
          <Grid.Row styleName="merit-scholarships-inner-grid-row">
            <Radio
              key={`scholarship-key-radio-audience-out-of-state-${index}`}
              data-cy="scholarship-key-radio-audience-out-of-state"
              label={intl.formatMessage(messages.meritScholarshipsOutOfStateStudentsLabel)}
              name={`audienceRadioGroup-${index}`}
              aria-label="Out of state students only"
              value="OUT_OF_STATE"
              checked={audience === 'OUT_OF_STATE'}
              onChange={(e, { value }) => onChange({ target: { value } }, 'audience')}
            />
          </Grid.Row>
          <Grid.Row styleName="merit-scholarships-inner-grid-row">
            <Radio
              key={`scholarship-key-radio-audience-custom-${index}`}
              data-cy="scholarship-key-radio-audience-custom"
              label={intl.formatMessage(messages.meritScholarshipsCustomStudentsLabel)}
              name={`audienceRadioGroup-${index}`}
              aria-label="Only students from states selected in dropdown below"
              value="CUSTOM"
              checked={audience === 'CUSTOM'}
              onChange={(e, { value }) => onChange({ target: { value } }, 'audience')}
            />
          </Grid.Row>
        </Grid>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row styleName="merit-scholarships-custom-states-row">
      <Grid.Column width={3} />
      <Grid.Column width={7}>
        <Dropdown
          styleName="merit-scholarships-custom-states-dropdown"
          key="scholarship-input-custom-states"
          data-cy="merit-scholarships-custom-states"
          aria-label="Choose States"
          placeholder="Select custom states"
          inputid="state-or-province"
          options={states.map((o) => ({ ...o, 'aria-label': o.value }))}
          onChange={(e, { value }) => onChange({ target: { value } }, 'audienceStates')}
          value={audience === 'CUSTOM' ? audienceStates : []}
          multiple
          disabled={audience !== 'CUSTOM'}
          minCharacters={1}
          search
          selection
        />
        {errors.requiredFieldsMissing.includes('audienceStates') && (
          <Label role="tooltip" basic color="red" pointing data-cy="merit-scholarships-audience-states-required-error" styleName="merit-scholarships-audience-states-error">
            <Icon name="exclamation circle" styleName="validationError" size="large" />
            <FormattedMessage {...messages.meritScholarshipsRequiredField} />
          </Label>
        )}
      </Grid.Column>
    </Grid.Row>
  </React.Fragment>
);

Audience.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  index: PropTypes.string,
  audience: PropTypes.string,
  audienceStates: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  errors: PropTypes.shape({
    requiredFieldsMissing: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default injectIntl(Audience);
